import React from 'react'
import { Region, type ComponentProps, type ExtendedRichTextData, type LayoutData } from '@enonic/react-components'
import ArticlePrototype from '/react4xp/components/prototype/Article'

type Author = {
	name: string
	role?: string
	avatar?: { src: string; alt: string }
}

type ArticleLayoutData = {
	title?: string
	intro?: string
	tags?: { value: string; label: string }[]
	image?: { src: string; alt?: string }
	body?: ExtendedRichTextData
	author?: Author
	error?: string
}

export const ArticleLayout = ({ component, data, meta }: ComponentProps<LayoutData>) => {
	const { title, intro, tags = [], image, body, author } = (data || {}) as ArticleLayoutData

	return (
		<>
			<ArticlePrototype
				title={title}
				intro={intro}
				tags={tags.map(({ label }) => ({ label }))}
				image={image?.src ? { src: image.src, alt: image.alt } : undefined}
				// Interim: `ArticleProps.body` is a plain HTML string, so <RichText> is skipped. Inline
				// images and links survive (already resolved in processedHtml), but registered macros
				// (quote, image-block, video) stay as inert <editor-macro> tags and the field is not
				// inline-editable. Needs the dual-shape body contract on the prototype side.
				body={body?.processedHtml}
				author={author}
			/>
			<Region name="main" data={component?.regions?.main?.components || []} meta={meta} />
		</>
	)
}
